import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export default function CenteredCardSkeleton() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-linen p-6" role="status" aria-label="Loading page">
      <Card className="w-full max-w-lg rounded-2xl border-dash-border p-8 shadow-none">
        <Skeleton className="mx-auto size-14 rounded-full" />
        <Skeleton className="mx-auto mt-6 h-8 w-3/5" />
        <Skeleton className="mx-auto mt-3 h-4 w-4/5" />
        <Skeleton className="mx-auto mt-2 h-4 w-2/3" />
        <div className="mt-8 rounded-xl border border-dash-border p-5"><Skeleton className="h-4 w-1/3" /><Skeleton className="mt-3 h-6 w-4/5" /><Skeleton className="mt-3 h-4 w-1/2" /></div>
        <Skeleton className="mt-6 h-11 w-full" />
        <span className="sr-only">Loading page details…</span>
      </Card>
    </div>
  );
}
